import type React from "react";

import { IconButton } from "@similarweb/ui-components";

import { useDraggableSideTab } from "app/custom-hooks/useDraggableSideTab";
import { translate } from "app/filters/i18nFilter";

import { SideTabWrapper, SideTabContentContainer } from "./SideTab.styled";

type FeedbackSideTabProps = {
    id?: string;
};

export const FeedbackSideTab: React.FC<FeedbackSideTabProps> = ({ id = "feedback-side-tab" }) => {
    const { wrapperRef, dragState, horizontalOffset, verticalOffsetDelta, handleMouseDown } = useDraggableSideTab({
        trackingEvent: "Homepage/provide feedback",
        verticalOffsetAdjustment: -80,
    });

    return (
        <SideTabWrapper
            ref={wrapperRef}
            id={id}
            isDragged={dragState}
            verticalOffset={verticalOffsetDelta}
            sideOffset={horizontalOffset}
            onMouseDown={handleMouseDown}
        >
            <SideTabContentContainer>
                <IconButton
                    type={"flat"}
                    iconName={"response"}
                >
                    {translate("feedback_tab.button")}
                </IconButton>
            </SideTabContentContainer>
        </SideTabWrapper>
    );
};
